export default "__VITE_ASSET__BhCDAKyL__"